const createKeyIndex = (index: number | string, location: string): string => {
  if (location.trim() === '') {
    return `${index}`
  }
  return `${index}-${location}`
}

export default createKeyIndex